/**
 * Pie Shopping — cash-back and coupons helper
 *
 * Exposes `assets/page/*` to every http(s) origin with no `use_dynamic_url` — a group
 * of small page-context shims (`suppressAlert.js`, `suppressConfirm.js`,
 * `suppressPrompt.js`) that suppress native dialogs while the extension automates
 * checkout. Each is fetchable from any page at a fixed URL.
 *
 * There are no images in the WAR group, so the primary signal fetches the most
 * distinctive script path. Serving any of these confirms the extension is installed.
 *
 * Manifest verified against version 1.33.6.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'nfadicbbecgbdbgbibgflooojfbolpgk';

export const pieShopping: ExtensionDefinition = {
  id: ID,
  name: 'Pie Shopping: AI Cash Back and Coupons',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 300_000,
  notes:
    'Exposes assets/page/* dialog-suppression shims to every http(s) origin with no ' +
    'dynamic URL. Detection is a single fetch and conclusive.',
  signals: [
    {
      id: 'war-suppress-alert-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch assets/page/suppressAlert.js — a page-context shim exposed to every ' +
        'http(s) origin at a fixed path.',
      weight: 1,
      run: () => probeFetch(ID, 'assets/page/suppressAlert.js'),
    },
    {
      id: 'war-suppress-confirm-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch assets/page/suppressConfirm.js — a second shim in the same group, ' +
        'corroborating the identification.',
      weight: 0.5,
      run: () => probeFetch(ID, 'assets/page/suppressConfirm.js'),
    },
    {
      id: 'war-suppress-prompt-js',
      kind: 'web-accessible-resource',
      description: 'Fetch assets/page/suppressPrompt.js — a third independent path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'assets/page/suppressPrompt.js'),
    },
  ],
};
